module.exports = __webpack_public_path__ + "img/post-switzerland-cod.2bc484f5.png";